import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { observable, computed, reaction } from 'mobx';
import { Model } from 'libx';
import moment from 'moment';
import { markdownToHtml } from '../utils/markdownUtil';
import { match } from '../utils/patternMatchUtil';
import { generateAvatarFallback } from '../utils/dummyImageUtil';
var Notification = (_class = /*#__PURE__*/function (_Model) {
  function Notification() {
    var _this;
    _classCallCheck(this, Notification);
    _this = _callSuper(this, Notification, arguments);
    _initializerDefineProperty(_this, "message", _descriptor, _this);
    _initializerDefineProperty(_this, "dateDispatch", _descriptor2, _this);
    _initializerDefineProperty(_this, "image", _descriptor3, _this);
    _initializerDefineProperty(_this, "action", _descriptor4, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor5, _this);
    _initializerDefineProperty(_this, "userId", _descriptor6, _this);
    _initializerDefineProperty(_this, "status", _descriptor7, _this);
    reaction(function () {
      return getUserIds(_this);
    }, function (idPairs) {
      _this.rootStore.memberStore.setAndFetch(idPairs.map(function (idPair) {
        return {
          workspace_id: _this.workspaceId,
          user_id: idPair.userId,
          user_public_id: idPair.userPublicId
        };
      }));
    }, {
      fireImmediately: true
    });
    return _this;
  }
  _inherits(Notification, _Model);
  return _createClass(Notification, [{
    key: "messageHtml",
    get: function get() {
      return markdownToHtml(this.message);
    }
  }, {
    key: "imageUrl",
    get: function get() {
      var _this2 = this;
      var image = this.image || {
        type: 'None'
      };
      return match(image.type, {
        None: function None() {
          var _this2$workspace, _this2$workspace$bran, _this2$workspace$bran2;
          return ((_this2$workspace = _this2.workspace) === null || _this2$workspace === void 0 ? void 0 : (_this2$workspace$bran = _this2$workspace.branding) === null || _this2$workspace$bran === void 0 ? void 0 : (_this2$workspace$bran2 = _this2$workspace$bran.logos) === null || _this2$workspace$bran2 === void 0 ? void 0 : _this2$workspace$bran2.icon) || null;
        },
        Static: function Static() {
          return image.url;
        },
        UserAvatar: function UserAvatar() {
          var member = _this2.rootStore.memberStore.forWorkspaceAndUserPublicId(_this2.workspaceId, image.user_public_id);
          return (member === null || member === void 0 ? void 0 : member.avatar) || (member === null || member === void 0 ? void 0 : member.avatarFallback) || null;
        }
      });
    }
  }, {
    key: "imageFallbackUrl",
    get: function get() {
      var _this3 = this;
      var image = this.image || {
        type: 'None'
      };
      return match(image.type, {
        None: function None() {
          var _this3$workspace;
          return generateAvatarFallback(((_this3$workspace = _this3.workspace) === null || _this3$workspace === void 0 ? void 0 : _this3$workspace.name) || ' ');
        },
        Static: function Static() {
          var _this3$workspace2;
          return generateAvatarFallback(((_this3$workspace2 = _this3.workspace) === null || _this3$workspace2 === void 0 ? void 0 : _this3$workspace2.name) || ' ');
        },
        UserAvatar: function UserAvatar() {
          var member = _this3.rootStore.memberStore.forWorkspaceAndUserPublicId(_this3.workspaceId, image.user_public_id);
          return (member === null || member === void 0 ? void 0 : member.avatarFallback) || generateAvatarFallback(' ');
        }
      });
    }
  }, {
    key: "workspace",
    get: function get() {
      return this.rootStore.workspaceStore.workspaces.get(this.workspaceId);
    }
  }, {
    key: "parse",
    value: function parse(json) {
      var id = json.id,
        workspace_id = json.workspace_id,
        status = json.status,
        message = json.message,
        date_dispatch = json.date_dispatch,
        action = json.action,
        user_id = json.user_id,
        user_public_id = json.user_public_id,
        image = json.image;
      if ((image === null || image === void 0 ? void 0 : image.type) === 'UserAvatar' && workspace_id) {
        this.rootStore.memberStore.setAndFetch({
          workspace_id: workspace_id,
          user_id: image.user_id,
          user_public_id: image.user_public_id
        });
      }
      return {
        id: id,
        message: message,
        status: status,
        action: action,
        image: image,
        userId: user_id,
        userPublicId: user_public_id,
        workspaceId: workspace_id,
        dateDispatch: moment(date_dispatch)
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "message", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dateDispatch", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "image", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "action", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "userId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Sent';
  }
}), _applyDecoratedDescriptor(_class.prototype, "messageHtml", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "messageHtml"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageFallbackUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageFallbackUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "workspace", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "workspace"), _class.prototype), _class);
export { Notification as default };
function getUserIds(notification) {
  var idPairs = [{
    userId: notification.userId,
    userPublicId: notification.userPublicId
  }];
  var image = notification.image;
  if (image && image.type === 'UserAvatar') {
    idPairs = [].concat(_toConsumableArray(idPairs), [{
      userId: image.user_id,
      userPublicId: image.user_public_id
    }]);
  }
  return idPairs.filter(function (pair) {
    return pair.userId && pair.userPublicId;
  });
}
//# sourceMappingURL=Notification.js.map
